// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `form {
  background-image: linear-gradient(to bottom, rgba(15, 26, 53, 0.3), rgba(15, 26, 53, 0.3)), url("/assets/images/auth-background.jpg");
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  height: calc(100vh - 70px);
  display: flex;
  align-items: center;
  justify-content: center;
}
form .loginButton {
  margin-top: 20px;
}
form .forgotPasswordLink {
  margin-top: 10px;
}
h1 {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0;
  line-height: normal;
  background: #0f1a35;
  color: white;
  width: 100%;
  padding: 22px;
  font-size: 26px;
  height: 30%;
}
h1 img {
  height: 100%;
}
h2 {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0;
  line-height: normal;
  color: #8e9bb5;
  font-weight: 300;
  font-size: 22px;
  height: 25%;
}
h2 .brblue {
  padding-left: 5px;
}
.form-group {
  background: white;
  border: 1px solid #8e9bb5;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  min-width: 320px;
  width: 45%;
  min-height: 350px;
  height: 40%;
  margin: 0;
}
.form-group .input-group {
  width: 70%;
  margin: auto;
}
.form-group .input-group:last-child {
  margin-top: 20px;
}
input[type="text"],
input[type="password"] {
  height: calc(1.5em + 0.5rem + 2px);
}
button[type=button] {
  display: block;
  background: #4b58a6;
  font-weight: 500;
  color: white;
  width: 200px;
  border-radius: 50px;
  padding: 10px 30px;
  margin: 5% auto;
  border: 0;
  transition: 0.5s;
  text-transform: uppercase;
}
button[type=button]:hover {
  background: #0f1a35;
}
button i {
  display: block;
  float: right;
  font-size: 10px;
  padding-top: 3px;
}
a {
  text-align: center;
  border: 0;
  padding: 0;
}
.alert {
  position: absolute;
  border-radius: 0;
  top: 20vh;
  left: 0;
  width: 100%;
  display: block;
}
`, "",{"version":3,"sources":["webpack://./src/app/auth/auth.component.less"],"names":[],"mappings":"AAEA;EACE,qIAAA;EACA,sBAAA;EACA,kCAAA;EACA,4BAAA;EACA,0BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AADF;AAPA;EAWI,gBAAA;AADJ;AAVA;EAeI,gBAAA;AAFJ;AAMA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,mBAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,eAAA;EACA,WAAA;AAJF;AAOA;EACE,YAAA;AALF;AAQA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,WAAA;AANF;AASA;EACE,iBAAA;AAPF;AAUA;EACE,iBAAA;EACA,yBAAA;EACA,aAAA;EACA,sBAAA;EACA,oBAAA;EACA,gBAAA;EACA,UAAA;EACA,iBAAA;EACA,WAAA;EACA,SAAA;AARF;AAWA;EACE,UAAA;EACA,YAAA;AATF;AAYA;EACE,gBAAA;AAVF;AAaA;;EACE,kCAAA;AAVF;AAaA;EACE,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,SAAA;EACA,gBAAA;EACA,yBAAA;AAXF;AAcA;EACE,mBAAA;AAZF;AAeA;EACE,cAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;AAbF;AAgBA;EACE,kBAAA;EACA,SAAA;EACA,UAAA;AAdF;AAiBA;EACE,kBAAA;EACA,gBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,cAAA;AAfF","sourcesContent":["@import (reference) \"../../styles.less\";\n\nform {\n  background-image: linear-gradient(to bottom, @overlay, @overlay), url(\"/assets/images/auth-background.jpg\");\n  background-size: cover;\n  background-position: center center;\n  background-repeat: no-repeat;\n  height: ~\"calc(100vh - @{header-height})\";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  .loginButton {\n    margin-top: 20px\n  }\n\n  .forgotPasswordLink {\n    margin-top: 10px;\n  }\n}\n\nh1 {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0;\n  line-height: normal;\n  background: @dkblue;\n  color: white;\n  width: 100%;\n  padding: 22px;\n  font-size: 26px;\n  height: 30%;\n}\n\nh1 img {\n  height: 100%;\n}\n\nh2 {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0;\n  line-height: normal;\n  color: @grey;\n  font-weight: 300;\n  font-size: 22px;\n  height: 25%;\n}\n\nh2 .brblue {\n  padding-left: 5px;\n}\n\n.form-group {\n  background: white;\n  border: 1px solid @grey;\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  min-width: 320px;\n  width: 45%;\n  min-height: 350px;\n  height: 40%;\n  margin: 0;\n}\n\n.form-group .input-group {\n  width: 70%;\n  margin: auto;\n}\n\n.form-group .input-group:last-child {\n  margin-top: 20px;\n}\n\ninput[type=\"text\"], input[type=\"password\"] {\n  height: calc(1.5em + .5rem + 2px);\n}\n\nbutton[type=button] {\n  display: block;\n  background: @mdpurple;\n  font-weight: 500;\n  color: white;\n  width: 200px;\n  border-radius: 50px;\n  padding: 10px 30px;\n  margin: 5% auto;\n  border: 0;\n  transition: 0.5s;\n  text-transform: uppercase;\n}\n\nbutton[type=button]:hover {\n  background: @dkblue;\n}\n\nbutton i {\n  display: block;\n  float: right;\n  font-size: 10px;\n  padding-top: 3px;\n}\n\na {\n  text-align: center;\n  border: 0;\n  padding: 0;\n}\n\n.alert {\n  position: absolute;\n  border-radius: 0;\n  top: 20vh;\n  left: 0;\n  width: 100%;\n  display: block;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
